import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClientService } from '../api/http-client.service';
import { MenuItem } from '../../features/home/models/menu-item.model';
import { MenuNodeDto, PermissionsResponseDto, UserPermissions } from './navigation.model';
import { dtoToMenuItems, dtoToPermissions } from './navigation.mapper';

/**
 * Frontera de navegación contra el backend. Ambos endpoints requieren Bearer
 * (lo adjunta el interceptor) y devuelven datos ya filtrados por el rol/scope
 * del usuario autenticado.
 */
@Injectable({ providedIn: 'root' })
export class NavigationApiService {
  private readonly http = inject(HttpClientService);

  /** Menú del usuario (árbol ya filtrado por rol). */
  getMenu(): Observable<MenuItem[]> {
    return this.http.get<MenuNodeDto[]>('navigation/menu').pipe(map(dtoToMenuItems));
  }

  /** Permisos y roles del usuario. */
  getPermissions(): Observable<UserPermissions> {
    return this.http
      .get<PermissionsResponseDto>('navigation/permissions')
      .pipe(map(dtoToPermissions));
  }
}
